const apiUrl = process.env.REACT_APP_API_URL

export default async function postVideo(body: FormData) {
    const token = localStorage.getItem('token')
    const videoResponse = await fetch(`${apiUrl}/video`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        body: body,
    })
    const videoJsonResponse: VideoResponse = await videoResponse.json()

    return videoJsonResponse
}

export async function processVideo(assessmentId: number) {
    const token = localStorage.getItem('token')
    const videoResponse = await fetch(`${apiUrl}/process/${assessmentId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })

    const videoJsonResponse: Response = await videoResponse.json()

    return videoJsonResponse
}

interface VideoResponse {
    videoPath: string
}

export async function getPresignedVideoUrl(
    assessmentId: number
): Promise<string> {
    const token = localStorage.getItem('token')
    const res = await fetch(`${apiUrl}/video/${assessmentId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
    const { videoUrl }: { videoUrl: string } = await res.json()
    return videoUrl
}
